// eslint-disable-next-line import/prefer-default-export
export const TAGS_AS_PRODUCTS_LIST = process.env.TAGS_AS_PRODUCTS_LIST
  ? JSON.parse(process.env.TAGS_AS_PRODUCTS_LIST)
  : [];
